import React from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'

import './styles.scss'
const bc = 'country-code-item'

const CountryCodeItem = ({ option, handleClick, className, getLabel, getValue, style }) => (
  <div className={cn(`${bc}__item`, { [className]: className })} onClick={handleClick} style={style}>
    <div className={`${bc}__item-flag`}>{getLabel(option)}</div>
    <span className={`${bc}__item-code`}>{getValue(option)}</span>
  </div>
)

CountryCodeItem.defaultProps = {
  getLabel: option => (option && option.label ? option.label : option),
  getValue: option => (option && option.value ? option.value : option),
}

CountryCodeItem.propTypes = {
  getLabel: PropTypes.func,
  getValue: PropTypes.func,
}

export default CountryCodeItem
